import { Checkbox, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

type Props = {
  form: any;
  setHaSidoObjetoDeAcosoSexual: (haSidoObjetoDeAcoso: boolean) => void;
};

const Component = ({ form, setHaSidoObjetoDeAcosoSexual }: Props) => {
  const { t } = useTranslation();

  // Combined harassment state
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [noneSelected, setNoneSelected] = useState(false);

  const manifestacionesAcosoSexual = [
    "Comentarios o bromas de contenido sexual o sexista.",
    "Comentarios o bromas sobre la orientación sexual o identidad de género.",
    "Comentarios o gestos sobre la apariencia física que generan incomodidad.",
    "Contacto reiterado sin fines laborales o invitaciones insistentes a salir.",
    "Compartir contenido íntimo sin consentimiento.",
    "Contacto físico no deseado o inapropiado para el contexto laboral (rozar, masajear, besar, abrazar).",
    "Insinuar, ofrecer beneficios o amenazar condiciones laborales a cambio de acercamientos, citas o favores de índole sexual.",
  ];

  const sexualOptions = manifestacionesAcosoSexual.map(
    (_, index) => `AT_${String(index + 1).padStart(3, "0")}AS`
  );

  // Combined manifestations array
  const allManifestaciones = [...manifestacionesAcosoSexual];

  // Generate combined options
  const allOptions = [...sexualOptions];
  const noneOption = "AT_001_NONE";

  // Update form and parent state for combined harassment
  useEffect(() => {
    if (noneSelected) {
      // When "Ninguna de las anteriores" is selected, set N.A values
      form.setFieldValue("AT_001_007AS", ["N.A"]);
      setHaSidoObjetoDeAcosoSexual(false);
    } else {
      // Normal behavior when specific manifestations are selected
      const sexualValues = selectedValues.filter((value) =>
        sexualOptions.includes(value)
      );
      form.setFieldValue("AT_001_007AS", sexualValues);
      setHaSidoObjetoDeAcosoSexual(sexualValues.length > 0);
    }
  }, [selectedValues, noneSelected]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCheckboxChange = (value: string) => {
    if (value === noneOption) {
      if (noneSelected) {
        setNoneSelected(false);
        setSelectedValues([]);
      } else {
        setNoneSelected(true);
        setSelectedValues([noneOption]);
      }
    } else {
      setNoneSelected(false);
      if (selectedValues.includes(value)) {
        setSelectedValues((prev) =>
          prev.filter((v) => v !== value && v !== noneOption)
        );
      } else {
        setSelectedValues((prev) => [
          ...prev.filter((v) => v !== noneOption),
          value,
        ]);
      }
    }
  };

  return (
    <Stack spacing="sm">
      <Text fw={500} size="sm" color="gray.8">
        En relación a la organización en la que estás actualmente, ¿en los
        últimos 12 meses has experimentado alguna de estas situaciones? Esto
        puede involucrar a personal de tu compañía como a personal de terceros o
        usuarios o clientes.
      </Text>
      <Text fz="xs" color="red">
        *Debes seleccionar al menos una opción.
      </Text>

      <Stack spacing={4}>
        {allManifestaciones.map((manifestacion, index) => (
          <Checkbox
            key={allOptions[index]}
            label={manifestacion}
            checked={selectedValues.includes(allOptions[index])}
            disabled={noneSelected}
            onChange={() => handleCheckboxChange(allOptions[index])}
            size="sm"
            styles={{
              body: { alignItems: "center" },
              label: {
                lineHeight: 1.4,
                minHeight: "2.8rem",
                display: "flex",
                alignItems: "center",
              },
            }}
          />
        ))}
        <Checkbox
          label="Ninguna de las anteriores"
          checked={noneSelected}
          onChange={() => handleCheckboxChange(noneOption)}
          size="sm"
          color="gray"
          styles={{
            body: { alignItems: "center" },
            label: {
              lineHeight: 1.4,
              minHeight: "2.8rem",
              display: "flex",
              alignItems: "center",
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

export default Component;
